import { Select } from 'antd';
import styled from 'styled-components';

// Same border and height as HSSearchInput so header controls match.
const FIELD_HEIGHT = '48px';
const FIELD_BORDER_COLOUR = '#ccdce4';
const FIELD_BORDER_RADIUS = '16px';
const POPUP_MENU_BORDER_COLOUR = '#ccdce4';
const POPUP_MENU_RADIUS = '8px';
const ICON_COLOUR = '#113e57';

// The popup is portalled outside the Select, so its root is styled through Select's `styles` prop.
export const HS_SELECT_POPUP_STYLE = {
  padding: '4px',
  borderRadius: POPUP_MENU_RADIUS,
  border: `1px solid ${POPUP_MENU_BORDER_COLOUR}`,
  boxShadow: '6px 6px 20px 0 rgba(4, 76, 123, 0.2)',
};

export const StyledSelect = styled(Select)`
  /* antd fixes the root at 32px; let it follow the selector so rows size and align correctly. */
  &&.ant-select {
    height: auto;
  }

  /* Specific enough to beat antd's base border, but not its hover/focus colours. */
  &&.ant-select .ant-select-selector {
    min-height: ${FIELD_HEIGHT};
    border: 1px solid ${FIELD_BORDER_COLOUR};
    border-radius: ${FIELD_BORDER_RADIUS};
    background: #ffffff;
  }

  .ant-select-prefix {
    display: flex;
    align-items: center;
    margin-inline-end: 10px;
  }

  .ant-select-selection-wrap {
    align-self: center;
  }

  .ant-select-selection-placeholder,
  .ant-select-selection-item-content {
    color: #525252;
    font-size: 16px;
    font-weight: 400;
  }

  /* Extra specificity: form Less (e.g. EditUserProfile) resets the arrow's margin and size. */
  &&& .ant-select-arrow {
    top: 50%;
    width: 22px;
    height: 22px;
    margin: 0;
    transform: translateY(-50%);
  }

  /* Not .status-icon: a global rule in DoorWindowChart.less adds padding and a background to it. */
  .expand-icon {
    width: 22px;
    height: 22px;
    fill: ${ICON_COLOUR};
  }
`;
